import React, { useCallback, useContext } from 'react';
import styles from '../farmFieldFlow.module.scss';
import { FormType } from 'enums/FieldTypeEnums';
import FieldsRow from 'shared/components/FieldsRow';
import { getSoilMatterField } from '../stage4FarmData';
import { debounce } from 'lodash';
import { STAGE_4 } from 'constants/FarmboxConstants/stage4.constants';
import { useFormContext } from 'react-hook-form';
import { HelpDeskContext } from 'context/HelpDeskContext';
import HelpdeskService from 'services/HelpdeskService/Helpdesk.service';
import { useParams } from 'react-router-dom';
import isProductDisabled from 'shared/utils/isProductDisabled';

const SoilOrganicCarbonSection = () => {
  const { setValue } = useFormContext();
  const { setHelpDeskData } = useContext(HelpDeskContext);
  const { fetchData } = HelpdeskService(setHelpDeskData);
  const { status } = useParams();
  const { REACT_HOOK_FORMS } = FormType;
  const { HEADING, INFO_TEXT } = STAGE_4;
  const { SOIL_ORGANIC_CARBON } = HEADING;
  const isDisabled = isProductDisabled(status);

  const debouncedSoilCalculation = useCallback(
    debounce(value => {
      setValue(
        'commodity.soil.organicCarbonPercentage',
        +(value * 0.58).toFixed(2),
        {
          shouldValidate: true,
        }
      );
    }, 500),
    [setValue]
  );

  return (
    <>
      <div className={styles.fieldHeaderContainer}>
        <h2 className={styles.headingContainer}>{SOIL_ORGANIC_CARBON}</h2>
      </div>
      <div className={styles.populatedFieldInfo}>
        <span className={styles.infoText}>{INFO_TEXT}</span>
      </div>
      <div className={styles.contentContainer}>
        <div className={styles.fieldRow}>
          <div className={styles.formFieldsContainer}>
            <FieldsRow
              {...getSoilMatterField({
                debouncedSoilCalculation,
                fetchData,
                isDisabled,
              })}
              formType={REACT_HOOK_FORMS}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default SoilOrganicCarbonSection;
